var _path, _g, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _circle, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsPopUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 208,
    viewBox: "0 0 200 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.154 193.51C185.614 176.28 199.31 150.109 199.31 120.798C199.31 68.9094 156.393 26.8455 103.453 26.8455C50.5116 26.8455 7.59375 68.9094 7.59375 120.798C7.59375 150.109 21.2901 176.28 42.7497 193.51C60.9063 193.215 81.5543 193.047 103.453 193.047C125.352 193.047 145.997 193.215 164.154 193.51Z",
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.999999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0874 201H186.809C188.57 201 189.997 199.602 189.997 197.876C189.997 196.15 188.57 194.749 186.809 194.749H29.0874C27.3254 194.749 25.8984 196.15 25.8984 197.876C25.8984 199.602 27.3254 201 29.0874 201Z",
    fill: "#C9C1AE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.945 34.2531C134.945 51.1262 120.985 64.8077 103.772 64.8077C86.5565 64.8077 72.5977 51.1262 72.5977 34.2531C72.5977 17.3801 86.5565 3.71094 103.772 3.71094C120.985 3.71094 134.945 17.3801 134.945 34.2531Z",
    fill: "#650D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.894 30.7548L101.401 44.0813C99.7995 45.3777 97.4255 45.1599 96.0939 43.5803L89.1461 35.333C87.8524 33.8003 88.0253 31.5403 89.5411 30.2154C91.1238 28.825 93.5659 28.9957 94.9353 30.5841L96.73 32.6845C98.0716 34.2358 100.436 34.4337 102.028 33.1385L112.663 24.4459C114.391 23.037 116.996 23.4143 118.232 25.2599L118.646 25.8747C119.708 27.4445 119.38 29.5536 117.894 30.7548Z",
    fill: "#FFFFF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.771 0C84.4985 0 68.8105 15.3639 68.8105 34.2533C68.8105 53.155 84.4985 68.5189 103.771 68.5189C123.056 68.5189 138.731 53.155 138.731 34.2533C138.731 15.3639 123.056 0 103.771 0ZM103.771 64.8078C86.5557 64.8078 72.5969 51.1263 72.5969 34.2533C72.5969 17.3802 86.5557 3.71108 103.771 3.71108C120.986 3.71108 134.945 17.3802 134.945 34.2533C134.945 51.1263 120.986 64.8078 103.771 64.8078Z",
    fill: "#650D1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.661 187L80.3056 186.978C75.0914 186.976 70.8661 183.33 70.8672 178.835L70.8885 85.1394C70.8896 80.6421 75.1209 76.9975 80.338 77L123.693 77.0219C128.907 77.0247 133.132 80.6697 133.131 85.1645L133.11 178.861C133.109 183.358 128.878 187.003 123.661 187Z",
    fill: "#1B1836"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.26 80.1355L115.616 80.1313C114.457 80.131 113.934 81.151 113.518 81.9671L112.896 83.2265C111.858 84.2642 110.423 85.3026 109.264 85.302L96.8113 85.302C95.6523 85.3013 94.7358 84.7831 93.6981 83.7454L92.4724 81.9567C92.1415 81.151 91.5328 80.1193 90.3738 80.1187L87.3342 80.1171L79.7694 80.1133C76.0125 80.1114 72.9653 82.6603 72.9645 85.8058L72.9434 177.132C72.9426 180.276 75.9853 182.825 79.7403 182.827L124.231 182.849C127.987 182.851 131.034 180.302 131.035 177.157L131.057 85.8299C131.057 82.6863 128.015 80.1374 124.26 80.1355Z",
    fill: "#F5EAD2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.1309,
    y: 93.6038,
    width: 14.5283,
    height: 14.5283,
    rx: 2,
    fill: "#C9C1AE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1309,
    y: 116.434,
    width: 14.5283,
    height: 14.5283,
    rx: 2,
    fill: "#C9C1AE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1309,
    y: 139.264,
    width: 14.5283,
    height: 14.5283,
    rx: 2,
    fill: "#C9C1AE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1309,
    y: 162.094,
    width: 14.5283,
    height: 14.5283,
    rx: 2,
    fill: "#C9C1AE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7734,
    y: 96.717,
    width: 18.6792,
    height: 3.11321,
    rx: 1.5566,
    fill: "#C9C1AE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7734,
    y: 102.943,
    width: 31.1321,
    height: 3.11321,
    rx: 1.5566,
    fill: "#C9C1AE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7734,
    y: 118.51,
    width: 18.6792,
    height: 3.11321,
    rx: 1.5566,
    fill: "#C9C1AE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7734,
    y: 124.736,
    width: 31.1321,
    height: 3.11321,
    rx: 1.5566,
    fill: "#C9C1AE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7734,
    y: 141.34,
    width: 18.6792,
    height: 3.11321,
    rx: 1.5566,
    fill: "#C9C1AE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7734,
    y: 147.566,
    width: 31.1321,
    height: 3.11321,
    rx: 1.5566,
    fill: "#C9C1AE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7734,
    y: 164.17,
    width: 18.6792,
    height: 3.11321,
    rx: 1.5566,
    fill: "#C9C1AE"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7734,
    y: 170.396,
    width: 31.1321,
    height: 3.11321,
    rx: 1.5566,
    fill: "#C9C1AE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 127.5,
    r: 34.5,
    fill: "#FFFFF6",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7458 100.797C71.1869 86.5456 47.5533 86.714 32.9631 101.175C18.3729 115.635 18.3468 138.914 32.9054 153.167C47.4643 167.419 71.087 167.24 85.678 152.78C100.268 138.319 100.304 115.05 85.7458 100.797ZM36.237 149.865C23.5087 137.404 23.5211 117.062 36.2777 104.42C49.0343 91.7774 69.6858 91.6389 82.4142 104.1C95.1327 116.55 95.1203 136.891 82.3624 149.535C69.6058 162.177 48.9556 162.315 36.237 149.865Z",
    fill: "#650D1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5649 154.863L35.1592 153.487L33.7535 152.111C33.7535 152.111 14.0013 167.985 8.32062 173.617C2.63996 179.248 -1.01181 184.664 1.36429 186.992C3.74144 189.32 9.21456 185.689 14.8966 180.056C20.5764 174.423 36.5649 154.863 36.5649 154.863Z",
    fill: "#650D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsPopUp);
export default __webpack_public_path__ + "static/media/contactUsPopUp.e2634bae30da6848db984d8a5113d02b.svg";
export { ForwardRef as ReactComponent };